/* eslint-disable no-unused-vars */
export const executePromiseMap = async (promiseMap = {}) => {
  const entries = Object.entries(promiseMap);
  const awaited = await Promise.allSettled(entries.map(([_, p]) => p));
  return Object.fromEntries(
    entries.map(([key], i) => [
      key,
      awaited[i]?.status === 'fulfilled'
        ? awaited[i]?.value
        : awaited[i]?.reason,
    ])
  );
};

export default { executePromiseMap };
